export interface RegiaoTableOptionsActions {
    canEdit: boolean;
    canImportOneErp: boolean;
}

export class RegiaoTableOptions implements RegiaoTableOptionsActions {
    canEdit: boolean;
    canImportOneErp: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
                this.canImportOneErp;
    }
}
